<template>
    <HeaderGame />
    <div class="game-content">
        <div class="tab-content">
            
            <!-- 标签栏 -->
            <van-row justify="center">
                <van-col :span="24">
                    <van-tabs @click-tab="switchTab" lazy-render color="#6387ea">
                        <!-- 推荐 -->
                        <van-tab title="推荐">
                            <div class="card-list">
                                <div class="card-item" v-for="item in playletList" :key="item.id"
                                    @click="goToDetail(item)">
                                    <div class="card-image-box">
                                        <img :src="item.plaIcon" class="card-image" />
                                        <div class="card-episode">
                                            <span>{{ item.plaTotal }}集全</span>
                                        </div>
                                    </div>
                                    <div class="card-title">{{ item.plaName }}</div>
                                </div>
                            </div>
                        </van-tab>

                        <!-- 我在追 -->
                        <van-tab title="我在追">
                            <div class="card-list" v-if="haveFollowData">
                                <div class="card-item" v-for="item in followList" :key="item.id"
                                    @click="goToDetail(item)">
                                    <div class="card-image-box">
                                        <img :src="item.plaIcon" class="card-image" />
                                        <div class="card-episode">
                                            <span>{{ item.plaTotal }}集全</span>
                                        </div>
                                    </div>
                                    <div class="card-title">{{ item.plaName }}</div>
                                </div>
                            </div>
                            <van-empty v-else description="暂无追剧数据" />
                        </van-tab>
                    </van-tabs>
                </van-col>
            </van-row>

            <!-- 下载 -->
            <van-row justify="center">
                <van-col :span="24">
                    <!-- <DownLoadApply /> -->
                </van-col>
            </van-row>

            <!-- 底部导航 -->
            <van-row justify="center">
                <van-col :span="24">
                    <nav-bar />
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
import NavBar from '@/components/NavBar'
// import DownLoadApply from '@/components/DownLoadApply'
import HeaderGame from '@/components/HeaderGame'
import { useRouter } from 'vue-router'
import { reactive, toRefs, onMounted } from 'vue'
import { getPlaylet, bingeWatchList } from '@/service/playlet'
import { Toast } from 'vant'
import { useStore } from 'vuex'

export default {
    name: 'playlet',
    components: {
        NavBar,
        // DownLoadApply,
        HeaderGame,
    },
    setup() {
        const router = useRouter()
        const store = useStore()

        const state = reactive({
            playletList: [],
            followList: [],
            haveFollowData: false,
        })

        // 跳转详情
        const goToDetail = (drama) => {
            router.push({
                path: '/shortDrama/videoDisplay',
                query: { id: drama.id, episodes: drama.plaTotal },
            })
        }

        // 获取推荐
        const getList = async () => {
            const result = await getPlaylet()
            if (result) state.playletList = result.list || []
        }

        // 获取追剧
        const getBingeWatch = async () => {
            const isLogin = store.getters.isLogin
            if (!isLogin) {
                Toast('请先登录')
                store.commit('setNeedLogin', true)
                return
            }

            const result = await bingeWatchList()
            if (result) {
                state.followList = result.list || []
                state.haveFollowData = state.followList.length > 0
            }
        }

        // 切换标签
        const switchTab = (data) => {
            if (data.name === 0) getList()
            if (data.name === 1) getBingeWatch()
        }

        onMounted(() => {
            getList()
        })

        return {
            ...toRefs(state),
            goToDetail,
            switchTab,
        }
    },
}
</script>

<style lang="less" scoped>
.game-content {
    width: 100%;
  background: #f2f5fa;
}

.tab-content {
    width: 100%;
}

/* 双列卡片布局 */
.card-list {
    width: 100%;
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    box-sizing: border-box;
    height: calc(var(--vh, 1vh) * 90);
    overflow-y: auto;
    padding-bottom: 70px;
    -webkit-overflow-scrolling: touch;
    /* 隐藏滚动条（核心三行） */
    scrollbar-width: none;          /* Firefox */
    -ms-overflow-style: none;       /* IE / Edge */
}

.card-item {
    width: calc(50% - 6px);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.card-image-box {
    width: 100%;
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    aspect-ratio: 16/9;
}

.card-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.card-episode {
    position: absolute;
    right: 6px;
    bottom: 6px;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.6);
    padding: 2px 6px;
    border-radius: 4px;
}

.card-title {
    margin-top: 6px;
    font-size: 14px;
    color: #333;
    text-align: center;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>